import {
  ASSUMPTIONS_STORE,
  BUDGET_IDX_KEYPATH,
  BUDGET_IDX_NAME,
  BUDGET_STORE,
  DUE_DATES_STORE,
  TEMPLATES_STORE,
} from "features/budget/budget.constants";
import {
  BUDGET_FILLING_STORE,
  BUDGET_DETAILING_STORE,
} from "features/overview-budget/state/budget.utils";

const idbStores = [
  {
    storeName: BUDGET_STORE,
  },
  {
    storeName: DUE_DATES_STORE,
    keyPath: "id",
    index: {
      name: BUDGET_IDX_NAME,
      keyPath: BUDGET_IDX_KEYPATH,
    },
  },
  {
    storeName: TEMPLATES_STORE,
    keyPath: "id",
    index: {
      name: BUDGET_IDX_NAME,
      keyPath: BUDGET_IDX_KEYPATH,
    },
  },
  {
    storeName: ASSUMPTIONS_STORE,
    keyPath: "id",
    index: {
      name: BUDGET_IDX_NAME,
      keyPath: BUDGET_IDX_KEYPATH,
    },
  },
  {
    storeName: BUDGET_FILLING_STORE,
  },
  {
    storeName: BUDGET_DETAILING_STORE,
  },
];

export default idbStores;
